export default __webpack_public_path__ + "static/media/onboarding-bg.7fc1ee67.png";